import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import {
  View,
} from '@uncinc/react-drupal-core';

import Modal from '../../containers/Modal';
import useClasses from '../../hooks/useClasses';
import { Main } from '../../components';

const PageBadges: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageBadges');

  return (
    <Modal
      className={buildClass()}
      title={t('pages.badges.title')}
      modalVisible
      closeModal={() => {
        history.goBack();
      }}
    >
      <Main className="col-lg-10 offset-lg-1 py-8 py-md-12">
        <View id="milestones" display="block_1" />
        <View id="badges" display="block_1" />
      </Main>
    </Modal>
  );
};

export default PageBadges;
